<template>
  <footer class="footer">
    <div class="container">
      <div class="footer-nav">
        <div class="single-item">
          <h3 class="title">O firmie</h3>
          <ul>
            <li>
              <a href="#">O nas</a>
            </li>
            <li>
              <a href="#">Dane przewoźnika</a>
            </li>
            <li>
              <a href="#">Dokumenty</a>
            </li>
            <li>
              <a href="#">Polityka prywatności</a>
            </li>
            <li>
              <a href="#">Kontakt</a>
            </li>
          </ul>
        </div>
        <div class="single-item">
          <h3 class="title">Zasoby</h3>
          <ul>
            <li>
              <router-link to="/my-tickets">Moje bilety</router-link>
            </li>
            <li>
              <router-link to="/terms">Regulamin</router-link>
            </li>
          </ul>
        </div>
        <div class="single-item">
          <h3 class="title">Inne informacje</h3>
          <ul>
            <li>
              <a href="#">Promocje i oferty</a>
            </li>
            <li>
              <a href="#">Pomoc</a>
            </li>
            <li>
              <a href="#">Opinie o nas</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="details">
        <div class="made-with">
          <span>© 2019 Zakotane Railway</span>
          <br>
          <span>Made with ♥︎ in Zakopane, Poland.</span>
        </div>
        <div class="social">
          <a href="#">
            <i class="fab fa-facebook-f"></i>
          </a>
          <a href="#">
            <i class="fab fa-twitter"></i>
          </a>
          <a href="#">
            <i class="fab fa-instagram"></i>
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
};
</script>

<style scoped>
.footer {
  background-color: var(--color-main);
  padding: 30px 0;
}

.footer-nav {
  display: flex;
  flex-flow: row wrap;
  margin: 0 0px;
  color: #fff;
}

.footer-nav .single-item {
  width: 33.333333%;
  display: flex;
  flex-flow: column nowrap;
  padding: 0 50px;
}

.footer-nav .single-item .title {
  font-size: 23px;
  margin: 0 0 20px;
  letter-spacing: 2px;
  border-bottom: 5px solid #fff;
  align-self: flex-start;
  padding: 0 10px 4px;
}

.footer-nav .single-item ul {
  margin: 0;
  padding-left: 30px;
}

.footer-nav .single-item li {
  list-style: none;
  margin: 7px 0;
}

.footer-nav .single-item li a {
  color: #fff;
  transition: color 0.3s ease;
}

.footer-nav .single-item li a:before {
  content: '\f105';
  font-family: 'Font Awesome 5 Free';
  font-weight: 900;
  padding-right: 5px;
}

.footer-nav .single-item li a:hover {
  color: var(--color-second);
}

.details {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  margin-top: 30px;
  color: #fff;
}

.details .made-with {
  font-weight: 300;
  font-size: 13px;
}

.details .social a {
  color: #fff;
  font-size: 20px;
  padding: 0 20px;
  margin: 0 10px;
  border: 1px solid transparent;
  border-radius: 4px;
  transition: color 0.3s ease, background-color 0.3s ease;
}

.details .social a:hover {
  color: var(--color-main);
  background-color: #fff;
}
</style>
